<template>
  <div>
    <v-menu
      v-model="opened"
      close-on-content-click
      open-on-hover
    >
      <template v-slot:activator="{ on }">
        <slot name="activator" v-bind:on="on">
        </slot>
      </template>
      <v-card class="mx-auto"
              min-width="400"
              max-width="500">
        <v-container>
          <px-cotacao-detalhes-volumes :cotacao="cotacao"/>
        </v-container>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import CotacaoDetalhesVolumes from '@/modules/cotacoes/detalhes/CotacaoDetalhesVolumes.vue';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      opened: false,
    };
  },
  methods: {
  },
  components: {
    pxCotacaoDetalhesVolumes: CotacaoDetalhesVolumes,
  },
};
</script>
